import { useCallback } from "preact/hooks";

import PropTypes from "prop-types";

GCXCustomizePersonalLeaderboard.propTypes = {
  currentDay: PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
  setCurrentDay: PropTypes.func.isRequired,
  days: PropTypes.arrayOf(PropTypes.string).isRequired,
  isLoadingTotals: PropTypes.bool.isRequired,
  currentTimeBlock: PropTypes.string,
  timeBlockLabels: PropTypes.arrayOf(PropTypes.string),
  setCurrentTimeBlock: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
};

export default function GCXCustomizePersonalLeaderboard({
  currentDay,
  setCurrentDay,
  days,
  isLoadingTotals,
  currentTimeBlock,
  timeBlockLabels,
  setCurrentTimeBlock,
  items,
}) {
  const getStreamerNameForDayAndTimeBlock = useCallback(
    (day, timeBlockLabel) => {
      const item = items.find((t) => {
        return t.day === day && t.timeBlockLabel === timeBlockLabel;
      });

      if (item) {
        return item.streamerName;
      } else {
        return "N/A";
      }
    },
    [items],
  );

  const isOptionDisabled = useCallback(
    (day, timeBlockLabel) => {
      const item = items.find((t) => {
        return t.day === day && t.timeBlockLabel === timeBlockLabel;
      });

      return !item;
    },
    [items],
  );

  return (
    <div className="w-full mb-4">
      <div className="ml-0.5 w-full">
        <fieldset className="fieldset w-full">
          <legend className="fieldset-legend">Day</legend>
          <select
            disabled={isLoadingTotals && days.length === 0}
            onChange={(e) => setCurrentDay(e.target.value)}
            value={`${currentDay}`}
            className="select select-bordered"
            name="day"
          >
            {days.map((day) => (
              <option key={day} value={`${day}`}>
                {day}
              </option>
            ))}
          </select>
        </fieldset>

        <fieldset className="fieldset w-full">
          <legend className="fieldset-legend">Time Block</legend>
          <select
            disabled={isLoadingTotals}
            onChange={(e) => setCurrentTimeBlock(e.target.value)}
            value={`${currentTimeBlock}`}
            className="select"
            name="timeBlock"
          >
            {timeBlockLabels.map((timeBlock) => (
              <option
                disabled={isOptionDisabled(currentDay, timeBlock)}
                key={timeBlock}
                value={`${timeBlock}`}
              >
                {timeBlock}
                {": "}
                {getStreamerNameForDayAndTimeBlock(currentDay, timeBlock)}
              </option>
            ))}
          </select>
        </fieldset>
      </div>
    </div>
  );
}
